import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontFamily from "assets/css/fontFamily";

export const wrapperCss = css`
  position: relative;
`;

export const inputCss = css`
  padding: 10px 32px 10px 12px;
  box-sizing: border-box;
  height: 32px;
  width: 100%;
  min-width: 220px;
  border: 1px solid ${colors.white};
  border-radius: 2px;
  background-color: ${colors.white};
  font-family: ${fontFamily.roboto};

  &:focus {
    outline: none;
    border: 1px solid ${colors.mainBlue};
  }
  &:disabled {
    background-color: ${colors.bgGrey};
    border: 1px solid ${colors.strokeGrey};
    color: ${colors.grey};
  }
  &::placeholder {
    color: ${colors.grey};
  }
`;

export const iconCss = css`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: ${colors.grey};
`;
